export default "__VITE_ASSET__Bas8zgUK__"